module.exports = __webpack_public_path__ + "static/media/bike-image-03.53c677e3.png";